import { motion } from "framer-motion";
import { Check, AlertCircle } from "lucide-react";
import { fadeInUp, simpleFade } from "./motion";

// Renders the standard ok/error feedback line used by Reserve & Contact.
// `variant` controls layout spacing: "block" stacks below input; "inline" sits beside the submit button.
export default function StatusMessage({
  status,
  errMsg,
  successText,
  successTestId,
  variant = "block",
  motionPreset = "slideUp",
}) {
  const motionProps = motionPreset === "fade" ? simpleFade : fadeInUp;
  const baseClass = variant === "inline"
    ? "inline-flex items-center gap-2 text-sm"
    : "mt-8 inline-flex items-center gap-2 text-sm";

  if (status === "ok") {
    return (
      <motion.p
        data-testid={successTestId}
        {...motionProps}
        className={baseClass}
        style={{ color: "var(--accent-rose)" }}
      >
        <Check size={16} /> {successText}
      </motion.p>
    );
  }

  if (status === "error") {
    return (
      <p className={baseClass} style={{ color: "#f87171" }}>
        <AlertCircle size={16} /> {errMsg}
      </p>
    );
  }

  return null;
}
